// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2wsID","footer":"ModalError_footer__1XlfF"};